interface WebpackModule {
    default?: unknown;
    [key: string]: unknown;
}

interface WebpackRequireContext {
    keys: () => string[];
    (filename: string): WebpackModule;
}

export const requiredAssetsToAssetMap = (requiredAssets: WebpackRequireContext): Record<string, unknown> =>
    requiredAssets.keys().reduce((assets: Record<string, unknown>, filename: string) => {
        const key = filename.replace(/^\.\//, '').replace(/\..*$/, '');
        const module = requiredAssets(filename);
        assets[key] = module.default ?? module;

        return assets;
    }, {});
